// removed by extract-text-webpack-plugin
module.exports = {"root":"show-header__root","heroContainer":"show-header__heroContainer","showHero":"show-header__showHero","hasVideo":"show-header__hasVideo","videoHero":"show-header__videoHero","meta":"show-header__meta","metaColumn":"show-header__metaColumn","nextShowing":"show-header__nextShowing show-header__metaColumn","sharingLinks":"show-header__sharingLinks show-header__metaColumn","newsHeadline":"show-header__newsHeadline"};


//////////////////
// WEBPACK FOOTER
// ./src/show-page/containers/show-header/styles.less
// module id = 502
// module chunks = 1